import { FC, useCallback } from 'react'
import styles from 'components/features/creditCard/creditCardPanes/paneComponents/CardShippingAddress.styl'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { shipmentAddressSelector } from 'components/features/creditCard/creditCardStore/selectors'
import { ccShipmentAddressGuard } from 'components/features/creditCard/creditCardStore/guards/ccShipmentAddressGuard'
import { useSimpleGuard } from 'helpers/loadableHelpers'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { killAllFloatingPanesActionCreator } from 'actions/floatingPanesActions'
import { showProfileEditFormActionCreator } from 'actions/settingsActions'

const CardShippingAddress: FC<{}> = () => {

  const isAddressLoaded = useSimpleGuard(ccShipmentAddressGuard, {}, 'ReplaceCardPane AddressStep')

  const shipmentAddress = useStoreSelector(shipmentAddressSelector)

  const dispatch = useStoreDispatch()
  const handleClose = useCallback(() => {
    dispatch(killAllFloatingPanesActionCreator())
    dispatch(showProfileEditFormActionCreator(true))
  }, [dispatch])

  if (!isAddressLoaded || !shipmentAddress) {
    return (
      <div className={ styles.address } >
        <LoadingOverlay />
      </div>
    )
  }

  return (
    <>
      <div className={ styles.address } >
        <div>{ shipmentAddress.street }</div>
        <div>
          {shipmentAddress.number}{shipmentAddress.refinement}
        </div>
        <div>
          {shipmentAddress.city.name}, {shipmentAddress.city.state.code}{' '}
          { shipmentAddress.zip5 }
        </div>
        <small>
          Edit your address on the&nbsp;
          <NavigationLink to='settings' onClick={ handleClose }>
            Settings Page
          </NavigationLink>
        </small>
      </div>
    </>
  )
}

export default CardShippingAddress
